export default __webpack_public_path__ + "static/media/normal exchange.efea7f94.svg";